import { render, staticRenderFns } from "./infobak.vue?vue&type=template&id=61d83e9e&scoped=true&lang=pug"
import script from "./infobak.vue?vue&type=script&lang=js"
export * from "./infobak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d83e9e",
  null
  
)

/* custom blocks */
import block0 from "./infobak.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports